<template>
  <b-form-input v-if="field.key"
                size="sm"
                :id="`type-${field.key}`"
                type="number"
                style="width: 48px;padding: 0;height: 21px;font-weight: bold"
                v-model="v"
                :class="{'border-red': hasChanged}"
                class="pull-right text-right"
                @input="handleInputChange(field)"
                :disabled="disabled || false"
  ></b-form-input>
</template>
<script>
export default {
  name: "IndexBBox",
  props: ["field", "val", "disabled"],
  data() {
    return {
      v: null,
      hasChanged: false,
    }
  },
  created() {
    this.v = this.field.value
  },
  watch: {
    field: {
      handler(nVal, oVal) {
        this.v = nVal?.value
      },
      deep: true
    }
  },
  methods: {
    handleInputChange() {
      this.hasChanged = true;
      this.$emit('changed', {key:this.field.key,value:this.v})
    }
  }
}
</script>
<style>
.border-red {
  border-color: rgba(255, 0, 0, .50);
}
</style>
